'use client';

import { FormatSimple, Tolgee, TolgeeProvider } from '@tolgee/react';
import { ReactNode } from 'react';
import da_DK from '../translations/locales/da_DK/common.json';
import de_AT from '../translations/locales/de_AT/common.json';
import de_BE from '../translations/locales/de_BE/common.json';
import de_CH from '../translations/locales/de_CH/common.json';
import de_DE from '../translations/locales/de_DE/common.json';
import en_IE from '../translations/locales/en_IE/common.json';
import en_US from '../translations/locales/en_US/common.json';
import es_ES from '../translations/locales/es_ES/common.json';
import fr_BE from '../translations/locales/fr_BE/common.json';
import fr_CH from '../translations/locales/fr_CH/common.json';
import fr_FR from '../translations/locales/fr_FR/common.json';
import it_CH from '../translations/locales/it_CH/common.json';
import it_IT from '../translations/locales/it_IT/common.json';
import nl_BE from '../translations/locales/nl_BE/common.json';
import no_NO from '../translations/locales/no_NO/common.json';
import pt_PT from '../translations/locales/pt_PT/common.json';
import sv_SE from '../translations/locales/sv_SE/common.json';
import varmepumpeDkLocale from '../translations/locales/varmepumpe-dk-override/common.json';
import vls_BE from '../translations/locales/vls_BE/common.json';

interface TranslationProviderProps {
  children: ReactNode;
  language: string;
}

export function TranslationProvider({
  children,
  language,
}: TranslationProviderProps) {
  return (
    <TolgeeProvider
      tolgee={Tolgee()
        .use(FormatSimple())
        .init({
          language,
          staticData: {
            'varmepumpe-dk-override': varmepumpeDkLocale,
            da_DK,
            de_AT,
            de_BE,
            de_CH,
            de_DE,
            en_IE,
            en_US,
            es_ES,
            fr_FR,
            fr_BE,
            fr_CH,
            it_CH,
            it_IT,
            nl_BE,
            no_NO,
            pt_PT,
            sv_SE,
            vls_BE,
          },
        })}
    >
      {children}
    </TolgeeProvider>
  );
}
